export default "__VITE_ASSET__DeECEEMV__"